module.exports = __webpack_public_path__ + "static/colouring_in_yarra-0669a65f44535cc5c9db4e930eb0cf35.pdf";